import DatetimeUtils from "../../../../../gd/utils/datetime-utils"
import {momentRange} from "../../../../../gd/convert/moment-range"

const debug = false
// const debug = "ReportDate"

export class ReportDate {
    lastDays    : number | null

    startDate   : Moment | null
    endDate     : Moment | null

    constructor(value: any) {

        this.lastDays   = _.get(value, 'lastDays', null)
        this.startDate  = DatetimeUtils.dateToMoment(_.get(value, 'startDate', null))
        this.endDate    = DatetimeUtils.dateToMoment(_.get(value, 'endDate', null))

        // this is a patch to prevent bad cases when nothing is set
        if (!this.lastDays && !this.startDate) {
            this.lastDays = 14
        }
    }

    isValid() {
        return !!this.lastDays || (!!this.startDate && !!this.endDate)
    }

    clone() {
        return new ReportDate(this.toJSON())
    }

    get startEnd() {
        if (this.lastDays) {
            return momentRange(momentDate().subtract(this.lastDays, 'days'),  momentDate())
        } else if (this.startDate && this.endDate) {
            return momentRange(this.startDate, this.endDate)
        }

        return momentRange(momentDate(), momentDate())
    }

    toRequestPayload() {
        debug && console.log(debug, 'toRequestPayload', this.startEnd)

        return {
            startDate   : DatetimeUtils.momentToDate(this.startEnd.start),
            endDate     : DatetimeUtils.momentToDate(this.startEnd.end),
        }
    }

    toJSON() {
        return _.omitBy({
            lastDays    : this.lastDays,
            startDate   : DatetimeUtils.momentToDate(this.startDate),
            endDate     : DatetimeUtils.momentToDate(this.endDate),
        }, _.isNil)
    }
}